export default __webpack_public_path__ + "static/media/LMGlogo.d87aad1d.png";